"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
/**
 * @author by Gor.Hakobyan on 11-Oct-19.
 */
var BackendToFrontendConvertUtil = /** @class */ (function () {
    function BackendToFrontendConvertUtil() {
    }
    BackendToFrontendConvertUtil.backendMultilingualToFrontendMultilingual = function (res) {
        if (!res) {
            return null;
        }
        return new idm_crosscutting_concepts_frontend_1.MultilingualString(BackendToFrontendConvertUtil.toMap(res));
    };
    BackendToFrontendConvertUtil.toMap = function (json) {
        var map = new Map();
        for (var k in json) {
            map.set(+k, json[k]);
        }
        return map;
    };
    return BackendToFrontendConvertUtil;
}());
exports.BackendToFrontendConvertUtil = BackendToFrontendConvertUtil;
//# sourceMappingURL=backend-to-frontend-convert.util.js.map